export default __webpack_public_path__ + "static/media/img18_s.8edd441c.png";